
export default function menuOpenSubmenu() {

	const mobileContainer = document.getElementById('menuMobile');
	const menuLinks = mobileContainer.querySelectorAll('ul li > a[href="#"]');

	menuLinks.forEach(link => {
		link.addEventListener('click', function (e) {
			e.preventDefault(); // ne ugorjon az oldal tetejére

			const parentLi = link.parentElement;
			const subMenu = parentLi.querySelector('ul');

			if (subMenu) {
				// Toggle: megjelenítés vagy eltüntetés
				if (subMenu.style.display === 'block') {
					subMenu.style.display = 'none';
				} else {
					subMenu.style.display = 'block';
				}
			}
		});
	});

}